module.exports = __webpack_public_path__ + "img/Frueher-768@2x.5987045a.jpg";